import { RootDispatch } from "@store";
import {
  ActionAddTimer,
  ActionClearTimers,
  ActionTimersIntervalStart,
  ActionTypes,
} from "./actionTypes";

export const addTimerAction = (
  timer: ActionAddTimer["payload"]
): ActionAddTimer => {
  return {
    type: ActionTypes.ADD_TIMER,
    payload: timer,
  };
};

export const calcTimersAction = (
  payload: ActionTimersIntervalStart["payload"]
) => {
  const changedPayload: ActionTimersIntervalStart["payload"] = {};

  for (const key in payload) {
    const each = payload[key] - 1;

    if (each < 1) {
      return {
        type: ActionTypes.STOP_INTERVAL,
        payload: key,
      };
    }
    changedPayload[key] = each;
  }

  return {
    type: ActionTypes.START_INTERVAL,
    payload: changedPayload,
  };
};

export const clearTimersAction = (): ActionClearTimers => {
  return {
    type: ActionTypes.CLEAR_TIMERS,
    payload: undefined,
  };
};
